import { render } from "./IconVehicleTruck.vue?vue&type=template&id=7d989bfe"
import script from "./IconVehicleTruck.vue?vue&type=script&lang=js"
export * from "./IconVehicleTruck.vue?vue&type=script&lang=js"

import exportComponent from "/var/local/jenkins-agent/data/agent/workspace/_Bitbucket_tvg-online-gui_master/tvg-online-ui/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__